import React from 'react'
import Profile from '../components/auth/profile/Profile';

const ProfilePage = () => {
    return (
        <div className='outletConainer'><Profile /></div>
    )
}

export default ProfilePage;